const Theme = {
  color: {
    primaryBg: "#000000",
    accent: "#F86600",
    secondaru: "rgba(248, 102, 0, 0.15)",
    fonst: "#FFFFFF",
  },
};

export default Theme;
